export default __webpack_public_path__ + "9bfdeed4da7cca6d2fd7c95e2d822ca6.jpg";